import dayjs from 'dayjs';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { JobseekerDriveSummary } from 'types';
import { CompanyLogo, DateBadge, PrimaryButton } from './shared';

const MAX_LOGOS = 4;

const DriveCard = ({ drive, className = 'max-w-[520px] w-full' }: { drive: JobseekerDriveSummary; className?: string }) => {
	const navigate = useNavigate();
	const extra = drive.companyLogos.length - MAX_LOGOS;

	return (
		<div className={`bg-white dark:bg-[#1F2937] rounded-[20px] border border-[#EEEEF5] shadow-[0_2px_12px_rgba(20,20,60,0.06)] overflow-hidden ${className}`}>
			<div className="p-4 tsm:p-5 flex gap-3 tsm:gap-4">
				<DateBadge date={drive.driveDate} endDate={drive.driveEndDate} />
				<div className="min-w-0 flex-1">
					<div className="flex flex-col items-start gap-1.5 md:flex-row md:justify-between md:gap-2">
						<h4 className="min-w-0 text-[18px] tsm:text-[20px] leading-[24px] tsm:leading-[28px] font-[700] text-[#111E2C] dark:text-white">{drive.name}</h4>
						<span className="px-2.5 tsm:px-3 py-0.5 tsm:py-1 rounded-full bg-[#F1F1F5] text-[#555770] text-[12px] tsm:text-[13px] font-[600] whitespace-nowrap shrink-0">
							{drive.companiesCount} {drive.companiesCount === 1 ? 'company' : 'companies'}
						</span>
					</div>
					<p className="text-[13px] tsm:text-[14px] text-[#555770] dark:text-[#B0B8C4] mt-1">
						{dayjs(drive.driveDate).format('h:mm A')} · {drive.location}
					</p>
					<div className="flex items-center mt-2.5 tsm:mt-3">
						{drive.companyLogos.slice(0, MAX_LOGOS).map((company, index) => (
							<div key={`${company.name}-${index}`} className={`${index ? '-ml-2' : ''} rounded-[10px] ring-2 ring-white`}>
								<CompanyLogo name={company.name} logo={company.logo} url={company.url} size={40} />
							</div>
						))}
						{extra > 0 ? <span className="ml-3 text-[14px] font-[600] text-[#8A8BA3]">+{extra} more</span> : null}
					</div>
				</div>
			</div>
			<div className="px-4 tsm:px-5 py-3 tsm:py-4 bg-[#F6F6FA] dark:bg-[#111827] flex items-center justify-between gap-3">
				<span className="text-[13px] tsm:text-[14px] font-[500] text-[#8A8BA3]">
					{drive.hasApplied ? 'You have applied' : `Application closes ${dayjs(drive.applicationCloseDate).format('D MMM')}`}
				</span>
				<PrimaryButton
					className="!py-2 shrink-0 !px-4 tsm:!px-6 !text-[14px] tsm:!text-[16px]"
					onClick={() => navigate(drive.hasApplied ? `/placement-drives/${drive._id}/status` : `/placement-drives/${drive._id}`)}
				>
					{drive.hasApplied ? 'View status' : 'View drive'}
				</PrimaryButton>
			</div>
		</div>
	);
};

export default DriveCard;
